import * as Account from 'app/entities/Account';
import * as Profile from 'app/entities/Profile';

export const getSwitchesFromState = state => {
  const currentAccount = Account.selectors.all.currentAccount(state);
  const currentProfile = Profile.selectors.all.currentProfile(state);

  const accountSwitches =
    currentAccount && currentAccount.data && currentAccount.data.switches
      ? currentAccount.data.switches
      : {};
  const profileSwitches =
    currentProfile && currentProfile.data && currentProfile.data.switches
      ? currentProfile.data.switches
      : {};

  return {
    ...accountSwitches,
    ...profileSwitches,
  };
};
